import React from 'react';
var ToggleSwitchSkeleton = function () { return (React.createElement("div", null,
    React.createElement("span", { className: "skeleton-line skeleton-h-lg skeleton-w-lg" }),
    React.createElement("div", { className: "d-flex mt-2 align-items-center" },
        React.createElement("span", { className: "skeleton-line skeleton-h-lg skeleton-w-sm" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md skeleton-w-sm mt-0 ml-2" })))); };
export default React.memo(ToggleSwitchSkeleton);
